/**
 * kpiOvertimeRecordByYearMonth模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const kpiOvertimeRecordByYearMonth = {
  // 添加或编辑
  insertOrUpdate(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByYearMonth/insertOrUpdate`,params);
  },
  // 分页查询
  pageKpiOvertimeRecordByYearMonth(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByYearMonth/page`,params);
  },
  // 删除单个附件
  deleteSingleAttatchment(params) {
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByYearMonth/deleteSingleAttatchment`,params);
  },
   // 查询
  select(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/kpiOvertimeRecordByYearMonth/select`,param);
  }
}

export default kpiOvertimeRecordByYearMonth



// WEBPACK FOOTER //
// ./src/api/kpiOvertimeRecordByYearMonth.js